<template>
  <v-container fluid class="px-0 quill">
    <label class="v-label v-label--active theme--light" v-if="label">{{ label }}</label>
      <vue-editor
        class="d-block"
        :editorOptions="options"
        :value="value"
        @input="onChange"
      >
      </vue-editor>
  </v-container>
</template>

<script>
export default {
  props: {
    value: { required: true },
    label: { type: String, required: false },
    options: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  },
  methods: {
    onChange (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style>
  .quill {
    color: black;
    margin-top: 5px;
  }
  .ql-editor {
    min-height: 100px !important;
  }
</style>
